import { createUseStyles } from 'react-jss';

export default createUseStyles({
  errorMessage: {
    color: '#E84118',
    fontSize: '12px',
    fontWeight: '500',
    paddingLeft: '16px',
    marginTop: '6px',
  },
});
